const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const createBooking = async (bookingData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/bookings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bookingData),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to create booking');
    }
    return data;
  } catch (error) {
    console.error('Error creating booking:', error);
    throw error;
  }
};

export const getBooking = async (bookingId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/bookings/${bookingId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch booking');
    }
    return data;
  } catch (error) {
    console.error('Error fetching booking:', error);
    throw error;
  }
};

export const initiatePayment = async (bookingId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/initiate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ bookingId }),
    });
    
    const html = await response.text();
    
    if (!response.ok) {
      throw new Error('Failed to initiate payment');
    }
    
    return { data: html };
  } catch (error) {
    console.error('Error initiating payment:', error);
    throw error;
  }
};

export const checkPaymentStatus = async (bookingId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/status/${bookingId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to check payment status');
    }
    return data;
  } catch (error) {
    console.error('Error checking payment status:', error);
    throw error;
  }
};